import {IDocumentTypeResponse} from './types';

export const DOCUMENTS_SLICE = 'DOCUMENTS_UPLOADING_SLICE';

export const FILE_UNIQUE_FIELD_NAME = 'fileName';

export const SIGN_UNIQUE_FIELD_NAME = 'fileName';

export const TOTAL_ENTITY = 'fileUpload';

export const NOT_FILLED_FIELDS_MESSAGE = 'Необходимо заполнить все обязательные поля';
export const NO_FILES_MESSAGE = 'Пожалуйста добавьте файлы для загрузки';
export const NO_HEADER_ORGANIZATION = 'Для этой организации в справочнике филиалов не '
    + 'заведена головная организация, загрузка файлов недоступна';
export const FILES_IS_EMPTY_MESSAGE = 'Добавленные файлы являются пустыми';

export const URL_REGEX = /(?<=\/)([a-z0-9]|\.)+/i;

export const DefaultRegion: IDocumentTypeResponse = {
    description: 'Прочий документ',
    id: '6',
    lookupCode: 'OTHER',
    lookupType: 'DOCUMENT_TYPE',
    meaning: 'Прочий документ',
};

export const SignatureStatus = {
    FOUND: 'Документ найден',
    NOT_FOUND: 'Документ не найден',
};

export const SingExtensions = {
    SET_SIGN_EXTENSIONS: 'SET_SIGN_EXTENSIONS',
    RESET_SIGN_EXTENSIONS: 'RESET_SIGN_EXTENSIONS',
};
